import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { createOptions } from '@/utils/arrayHelper'
import { camelToWords } from '@/utils/stringHelper'
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import CostCenterService from './costCenter.service'

//TODO: Test
export const useCostCenter = () => {
  const service = new CostCenterService()
  const baseCrud = useCrud(API_RESOURCE.COST_CENTER, service)

  const queryClient = useQueryClient()

  const useFetchCostCenterUsers = (parameter = {}) => {
    const { page, pageSize, sortBy = '', orderBy = 1, filters = {} } = parameter
    return useQuery({
      queryKey: [...baseCrud.queryKey.list(parameter), 'user'],
      queryFn: () => service.fetchCostCenterUsers(parameter),
      placeholderData: keepPreviousData,
    })
  }

  const useUploadCostCenters = () => {
    return useMutation({
      mutationFn: (file) => service.uploadCostCenter(file),
      onSuccess: (res) => {
        toast.info(`Successfully Upload  ${camelToWords(API_RESOURCE.COST_CENTER)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }
  const useUploadUserInCostCenters = () => {
    return useMutation({
      mutationFn: (file) => service.uploadUserInCostCenter(file),
      onSuccess: (res) => {
        toast.info(`Successfully Upload User in ${camelToWords(API_RESOURCE.COST_CENTER)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useCostCenterOptions = (payload = {}) => {
    const { status = 'active', labelType = 'simple', valueKey = 'profitCenterCode' } = payload
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: status } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: status } }),
      placeholderData: keepPreviousData,
      select: (data) => {
        if (labelType === 'simple') {
          return createOptions(data?.data, 'profitCenterCode', valueKey)
        }
        return createOptions(
          data?.data,
          (costCenter) => `${costCenter.profitCenterCode || ''} - ${costCenter.name || ''}`,
          valueKey
        )
      },
    })
  }

  return {
    //Base CRUD
    useFetchAllCostCenters: baseCrud.useFetchAll,
    useFetchCostCenter: baseCrud.useFetchOne,
    useCreateCostCenter: baseCrud.useCreate,
    useUpdateCostCenter: baseCrud.useUpdate,
    useRemoveCostCenter: baseCrud.useRemove,

    //Extra
    useFetchCostCenterUsers,
    useUploadCostCenters,
    useUploadUserInCostCenters,
    useCostCenterOptions,
  }
}
